import {
    APPOINTMENT_SCHEDULE_REQUEST, APPOINTMENT_SCHEDULE_RECEIVE, APPOINTMENT_SCHEDULE_FAILURE,
    SELECT_APPOINTMENT_SCHEDULE,
    SELECT_SERVICE,
    SELECT_CABINET,
    RESET_SCHEDULE, SELECT_GENDER
} from '../constants/schedule';


/*const tempalte = {
    cabinetIds: [1, 2],
    cabinets: {
        1: {
            dates: ['19.11.2018', '20.11.2018'],
            schedule: [
                []
            ]
        },
        2: {
            dates: ['19.11.2018', '20.11.2018'],
            schedule: [
                [],
            ]
        }
    }
};*/

const initialState = {
    cabinetIds: [],
    cabinets: {},
    offset: 0,
    selectedServiceId: null,
    selectedCabinetId: null,
    selectedSchedule: null,
    selectedGender: null,
    loading: {}
};


export default (state = initialState, action) => {
    switch (action.type) {
        case APPOINTMENT_SCHEDULE_REQUEST:
            return state;

        case APPOINTMENT_SCHEDULE_RECEIVE: {
            const payload = action.payload;
            const { cabinetIds, cabinets } = payload.schedules.reduce((accumulator, cabinet) => {
                const { cabinetId } = cabinet;
                accumulator.cabinetIds = [...accumulator.cabinetIds, cabinetId];
                accumulator.cabinets[cabinetId] = {
                    dates: cabinet.data.dates,
                    schedules: cabinet.data.schedules.map(row =>
                        row.map((column) => {
                            return column
                        })
                    )
                };
                return accumulator;
            }, { cabinetIds: [], cabinets: {} });
            return { ...state, cabinetIds, cabinets, offset: payload.offset };
        }

        case APPOINTMENT_SCHEDULE_FAILURE:
            return state;

        case SELECT_APPOINTMENT_SCHEDULE: {
            const selectedSchedule = action.payload;
            return {...state, selectedSchedule };
        }

        case SELECT_SERVICE: {
            const serviceId = action.payload;
            return { ...state, selectedServiceId: serviceId, selectedCabinetId: null, selectedSchedule: null };
        }

        case SELECT_CABINET: {
            const cabinetId = action.payload;
            return { ...state, selectedCabinetId: cabinetId, selectedSchedule: null };
        }

        case SELECT_GENDER: {
            const gender = action.payload;
            return { ...state, selectedGender: gender, selectedSchedule: null };
        }

        case RESET_SCHEDULE: {
            return {
                cabinetIds: [],
                cabinets: {},
                offset: 0,
                selectedServiceId: null,
                selectedCabinetId: null,
                selectedSchedule: null,
                selectedGender: null,
                loading: {}
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// frontend/src/modules/mobile/reducers/schedule.js